var app = app || {};
(function () {
    //abp.services.app.session.getCurrentLoginInformations({ async: false })
    //    .done(function (result) {
    //        app.session = result;
    //    });
    const script = document.getElementById("ScriptSession");
    if (script) {
        app.session = JSON.parse(script.textContent);
    }
})();
